import useSubscriptions from '../hooks/useSubscriptions'

const RootSubscriptions = () => {
  useSubscriptions()

  return null
}

export default RootSubscriptions
